import React from 'react';
import Label from '../../Fields/Label/Label';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';

const LabelWithContent = (props) => {
  const { label, content, wrapperStyle, labelStyle, optional, } = props;
  const styles = useStyles({ wrapperStyle, });

  return (
    <div className={styles.wrapper}>
      <Label label={label} optional={optional} labelStyle={{ width: 'auto', marginBottom: 0, ...labelStyle, }}>
        {content}
      </Label>
    </div>
  );
};

const useStyles = createUseStyles({
  wrapper: (props) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    ...props.wrapperStyle,
  }),
});

LabelWithContent.propTypes = {
  label: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  wrapperStyle: PropTypes.object,
  labelStyle: PropTypes.object,
  optional: PropTypes.bool,
}

LabelWithContent.defaultProps = {
  optional: true,
  wrapperStyle: {},
  labelStyle: {},
}

export default LabelWithContent;
